//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.InspectionProbeTipTypeBuilder.js";
import "../CAM/CAM.InspectionSensorStrategyBuilder.js";
let d=[[[0,"AngleA",1,0],[0,"AngleB",1,0],[0,"ApproachDistance",1,0],[0,"MotionType",1,0],[0,"ProbeTipType",1,0],[1,"ProbeTipTypeBuilder",0,"CAM.InspectionProbeTipTypeBuilder",0],[0,"RetractDistance",1,0],[0,"SensorOpName",1,0],[0,"SensorStrategy",1,0],[1,"SensorStrategyBuilder",0,"CAM.InspectionSensorStrategyBuilder",0],[0,"TipAngleMode",1,0],[0,"TipMode",1,0],[0,"TipNumber",1,0]],[[["parent"],"SetParent",{},1,0],[["sibling"],"SetSibling",{},1,0],[[],"SetProbeAngles",{},0,0],[[],"SetProbeTip",{},0,0],[["lock"],"LockMove",{},1,0]],[]];
SPLM.CAM.InspectionMoveBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionMoveBuilder.SensorStrategyTypes = Object.freeze({
    "CreateAsNeeded" : "CreateAsNeeded", "UseExisting" : "UseExisting"});

SPLM.CAM.InspectionMoveBuilder.TipModeTypes = Object.freeze({
    "Auto" : "Auto", "Specify" : "Specify", "Existing" : "Existing"});

SPLM.CAM.InspectionMoveBuilder.TipAngleTypes = Object.freeze({
    "Auto" : "Auto", "Specify" : "Specify", "Existing" : "Existing"});

SPLM.CAM.InspectionMoveBuilder.DepthMethodTypes = Object.freeze({
    "Auto" : "Auto", "Distance" : "Distance", "FromFeatureNominal" : "FromFeatureNominal", "FromFeatureActual" : "FromFeatureActual", "FromDatum" : "FromDatum"});

SPLM.CAM.InspectionMoveBuilder.ProbeTipTypes = Object.freeze({
    "Any" : "Any", "Sphere" : "Sphere", "Cylinder" : "Cylinder", "Disk" : "Disk"});

export default SPLM;